export const getLifeAndDisabilityInsuranceDescriptionTitles = (type: string) => {
    switch (type) {
      case 'long-term-disability':
        return <span>
          Want to know about Long-Term Disability?
        </span>;
      default:
        return <span></span>;
    }
  };
  
  export const getLifeAndDisabilityInsuranceDescription = (type: string, more: boolean) => {
    switch (type) {
      case 'long-term-disability':
        return <span>
          The Long-Term Disability (LTD) insurance plan offers income replacement if 
          you become disabled because of a covered sickness or injury. The amount of 
          your benefit depends upon the coverage option you choose and your annual 
          base pay, which is determined as of the later of December 1 of the prior 
          plan year or your date of hire.          
          {more && <div className="mt-10">
            <ul>
              <li>
                LTD insurance replaces either 50% or 60% of your annual base pay 
                if you become disabled because of a covered sickness or injury.
              </li>
              <li>
                Benefits begin after you have been disabled for 180 calendar days 
                (subject to all plan provisions).
              </li>
              <li>
                If you elect the 50% option, your maximum monthly benefit is $25,000 
                offset by any other income benefits. If you elect the 60% option, 
                your maximum monthly benefit is $30,000 offset by any other income benefits.
              </li>
              <li>
                If you die while receiving benefits, your dependents may be eligible 
                for a survivor benefit.
              </li>
            </ul>
            <div>
              The plan will not pay disability benefits for any period of disability 
              caused by, contributed by, or resulting from, a pre-existing condition. 
              A “pre-existing condition” includes any injury or illness for which you 
              incurred expenses, received medical treatment (including diagnostic 
              measures), took prescribed drugs or medicines, or consulted a physician. 
              There are two pre-existing condition limitations depending on your 
              maximum covered benefit amount.
            </div>
          </div>}
        </span>;
      default:
        return <span></span>;
    }
  };
  